<div class="inbound-numbers-list__header">
  <button
    type="button"
    class="btn btn-sm btn-primary inbound-numbers-list__add"
    (click)="openAdd()">
    <i class="pi pi-plus" aria-hidden="true"></i>
    <span>{{ 'Settings::PhoneNumbers:AddInboundNumber' | abpLocalization }}</span>
  </button>
</div>

<div class="card inbound-numbers-list__card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="items"
      [totalRecords]="totalRecords"
      [loading]="loading"
      [first]="skipCount"
      [rows]="rows"
      (lazyLoad)="onLazyLoad($event)" />
  </div>
</div>

<ng-template #numberTpl let-row>
  <div class="inbound-numbers-list__stack">
    <span class="inbound-numbers-list__primary">{{ row.phoneNumber }}</span>
    <span class="inbound-numbers-list__muted">{{ getProviderLabel(row.provider) }}</span>
  </div>
</ng-template>

<ng-template #routingTpl let-row>
  <span>{{ getRoutingLabel(row.routingType) }}</span>
</ng-template>

<ng-template #ivrTpl let-row>
  <div class="inbound-numbers-list__stack">
    <span class="inbound-numbers-list__primary">{{ row.ivrInstanceName || '—' }}</span>
    @if (row.ivrExtension) {
      <span class="inbound-numbers-list__ext-row">
        <code
          class="inbound-numbers-list__ext-chip"
          [pTooltip]="row.ivrExtension"
          tooltipPosition="top">
          {{ getExtensionShort(row.ivrExtension) }}
        </code>
        <button
          type="button"
          class="inbound-numbers-list__copy-btn"
          [pTooltip]="'Settings::PhoneNumbers:CopyExtension' | abpLocalization"
          tooltipPosition="top"
          (click)="copyExtension(row.ivrExtension); $event.stopPropagation()">
          <i class="pi pi-copy" aria-hidden="true"></i>
        </button>
      </span>
    }
  </div>
</ng-template>

<ng-template #statusTpl let-row>
  <p-tag
    [value]="
      isActive(row)
        ? ('Settings::PhoneNumbers:Active' | abpLocalization)
        : ('Settings::PhoneNumbers:Inactive' | abpLocalization)
    "
    [severity]="isActive(row) ? 'success' : 'secondary'">
  </p-tag>
</ng-template>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)"></app-action-menu>
</ng-template>

<app-inbound-number-form
  *ngIf="showForm"
  [visible]="true"
  [isEdit]="isEditMode"
  [model]="selectedItem"
  (visibleChange)="onFormVisibilityChange($event)"
  (saved)="onFormSaved($event)" />
